<template>
	<div>

		<div class="uk-container-expand footer uk-flex uk-flex-center uk-flex-middle">
			<p v-html="ms" class="uk-margin-remove"> </p>
		</div>
		
		<div style="background-color:#607D8B; padding:15px 0;" class="uk-container-expand uk-flex uk-flex-center uk-flex-middle">
			<a style="color:#fff; text-decoration:none; font-size:11px; 	text-transform: uppercase;" href="https://pavelcity.github.io/" target="_blank">перейти на страницу разработчика <i class="mdi mdi-open-in-new" style="margin-left:15px;"></i></a>
		</div>

	</div>
</template>

<script>
export default {
	data () {
		return {
			ms: 'Хлебная мануфактура «ГРIДНЕВЪ» &copy; &nbsp;  | &nbsp;  2012 - 2020'
		}
	}
}
</script>


<style>
.footer {
	background-color: #2c3e50;
	color:#fff;
	height: 60px;
}
</style>